import * as React from "react";

import { cn } from "@/lib/utils";

/** True when a stat has something to show. Blank strings count as empty. */
export const hasStatValue = (value: React.ReactNode | null | undefined): boolean =>
  value !== null &&
  value !== undefined &&
  value !== false &&
  !(typeof value === "string" && value.trim() === "");

interface StatProps {
  label: React.ReactNode;
  /** When null / undefined / blank, the stat renders nothing. */
  value?: React.ReactNode | null;
  sub?: string;
  big?: boolean;
  className?: string;
}

/**
 * A single stat — label + tabular value. A missing figure is omitted, never
 * shown as a dash, 0 or N/A: a dash reads as the organization withholding
 * information (org admin feedback, 2026-09-15).
 */
const Stat = ({ label, value, sub, big, className }: StatProps) => {
  if (!hasStatValue(value)) return null;
  return (
    <div className={className}>
      <div className="eyebrow text-[10.5px] text-ink-500">{label}</div>
      <div
        className={cn(
          "mt-[7px] font-bold leading-none tabular-nums tracking-[-0.015em] text-ink-900",
          big ? "text-3xl" : "text-2xl",
        )}
      >
        {value}
      </div>
      {sub && <div className="mt-1.5 text-[12.5px] text-ink-500">{sub}</div>}
    </div>
  );
};

export default Stat;
